import { render, staticRenderFns } from "./PrimaryInput.vue?vue&type=template&id=38a0da5d&scoped=true&"
import script from "./PrimaryInput.vue?vue&type=script&lang=js&"
export * from "./PrimaryInput.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryInput.vue?vue&type=style&index=0&id=38a0da5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a0da5d",
  null
  
)

export default component.exports